import { render, staticRenderFns } from "./homeCategory.vue?vue&type=template&id=68c274ec&scoped=true"
import script from "./homeCategory.vue?vue&type=script&lang=js"
export * from "./homeCategory.vue?vue&type=script&lang=js"
import style0 from "./homeCategory.vue?vue&type=style&index=0&id=68c274ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c274ec",
  null
  
)

export default component.exports